import { Data, Router } from "@angular/router";
import { Observable } from "rxjs";

export type LayoutResolver = (router: Router, params?: any) => string | Promise<string>;

export interface RouteDataWithInlineLayout {
  layout: string | LayoutResolver;
  layoutParams?: any;
  layoutIgnoreInheritedParams?: boolean;
};

export interface RouteDataWithByObjectLayout {
  layout: {
    name: string | LayoutResolver;
    params?: any;
  };
  layoutIgnoreInheritedParams?: boolean;
};

export type RouteDataWithLayout = RouteDataWithInlineLayout | RouteDataWithByObjectLayout;

export function isRouteDataWithByObjectLayout(layout: any): layout is RouteDataWithByObjectLayout {
  if (typeof layout.layout === 'object' && 'name' in layout.layout) {
    return true;
  }

  return false;
}

export function isRouteDataWithInlineLayout(layout: any): layout is RouteDataWithInlineLayout {
  if (typeof layout.layout === 'string' || typeof layout.layout === 'function') {
    return true;
  }

  return false;
}

export function isRouteDataWithLayout(routeData: Data): routeData is RouteDataWithLayout {
  if ('layout' in routeData) {
    return isRouteDataWithByObjectLayout(routeData) || isRouteDataWithInlineLayout(routeData);
  }

  return false;
}
